export default {
  name: 'CreditCardAddress',
  props: {
    card: Object
  }
};